export const Severity = Object.freeze({
  /**
   * Services are working as expected
   */
  HEALTHY: 'Healthy',
  /**
   * Services may be runing slow but are otherwise functional
   */
  DEGRADED: 'Degraded',
  /**
   * Services may not be functional at all or at a severly reduced rate
   */
  UNHEALTHY: 'Unhealthy',
  /**
   * A notification that could be used to notify of upcoming maintenance or service degredation
   */
  ADVISORY: 'Advisory',
})
